import { Link } from 'react-router-dom';
import { useAuth, useTranslation } from '@/hooks';
import { User } from '@/types/model';

interface UserCreatorLabelProps {
  user: Pick<User, 'createdBy' | 'createdByUserId'>;
  compact?: boolean;
}

export default function UserCreatorLabel({ user, compact = false }: UserCreatorLabelProps) {
  const { t } = useTranslation();
  const { user: currentUser } = useAuth();
  const creator = user.createdBy?.trim();

  if (!creator || !currentUser) return null;

  const isCurrentUserCreator = creator === currentUser.username?.trim();

  if (isCurrentUserCreator) return null;

  return (
    <span className="block text-xs font-normal text-gray-500">
      {compact ? t.users.by : t.users.createdBy}{' '}
      {user.createdByUserId != null ? (
        <Link
          to={`/users/${user.createdByUserId}/edit`}
          className="link inline-block max-w-40 truncate align-bottom hover:underline focus-visible:underline"
          title={creator}
        >
          {creator}
        </Link>
      ) : (
        <span>{creator}</span>
      )}
    </span>
  );
}
